import { RouteObject } from "react-router-dom";
import BillFlow from "./components/billFlow/billFlow";
import SingleBillCreateDraft from "../single-bill/create/SingleBillCreateDraft";
import SIngleBillList from "../single-bill/landing/SIngleBillList";
export interface SingleBillGenerationRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SingleBillGenerationRoute[];
}
export const bxSingleBillGenarationRoutes: SingleBillGenerationRoute[] = [
  {
    path: "bx/single-bill-generation",
    element: <SingleBillCreateDraft />,
  },
  {
    path: "bx/single-bill-generation/:id/:action",
    element: <SingleBillCreateDraft />,
  },
  {
    path: "bx/single-bill-generation/:id/:draftId/:action",
    element: <SingleBillCreateDraft />,
  },
  {
    path: "bx/single-bill",
    element: <SIngleBillList />,
  },
];
